
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Repeater from "@/components/Reusable/CustomInputs/Repeater/Repeater.vue";
import DropdownInput from "@/components/Reusable/CustomInputs/DropdownInput.vue";
import {
  MediaOptions,
  MediaOptionsType,
  MediaOptionsTypeV
} from "@/types/media";

const DEFAULT_MEDIA_OPTIONS = {
  acceptedFileTypes: undefined,
  multiple: false
};

@Component({
  components: { DropdownInput, Repeater }
})
export default class ElementStudioMediaOptions extends Vue {
  @Prop()
  value!: MediaOptions | null;

  get fileTypesEnabled() {
    return Array.isArray(this.internalValue.acceptedFileTypes);
  }

  get types() {
    return MediaOptionsTypeV.types.map(type => type.value);
  }

  get internalValue() {
    return this.value || DEFAULT_MEDIA_OPTIONS;
  }

  updateType(acceptedFileTypes: MediaOptionsType[] | undefined) {
    this.emit({
      ...this.internalValue,
      acceptedFileTypes
    });
  }

  updateMultiple(multiple: boolean) {
    this.emit({
      ...this.internalValue,
      multiple
    });
  }

  updateEnableFileTypes(enabled: boolean) {
    if (enabled) {
      this.updateType([]);
    } else {
      this.updateType(undefined);
    }
  }

  emit(mediaOptions: MediaOptions) {
    this.$emit("input", mediaOptions);
  }
}
